import { useEffect, useState } from 'react';
import { RegionInfoDto } from '@sr/dto';
import { useSnack } from 'shared/ui/snack';
import { fetchRegionsDropdown } from 'shared/api/regions';

interface UseRegionsOptions {
  load?: boolean;
  countryId?: number | null;
}

const useRegions = (options: UseRegionsOptions = {}) => {
  const { load = true, countryId } = options;
  const { showError } = useSnack();
  const [list, setList] = useState<RegionInfoDto[]>([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!load) return;

    setLoading(true);
    
    fetchRegionsDropdown(countryId)
      .then(response => {
        setList(response);
      })
      .catch(error => showError(error))
      .finally(() => {
        setLoading(false);
      });
  }, [load, countryId, showError]);

  return {
    list,
    loading
  };
};

export default useRegions;
